export function formatDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
}

export function daysUntil(iso) {
  if (!iso) return null;
  const d = new Date(iso + (iso.length === 10 ? "T00:00:00" : ""));
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const diff = Math.ceil((d.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
  return diff;
}

export function getExpiryStatus(expiryDate, daysThreshold = 7) {
  if (!expiryDate) return { label: "Senza scadenza", cls: "badge-good" };
  const days = daysUntil(expiryDate);
  if (days < 0) return { label: `Scaduto (${Math.abs(days)}g)`, cls: "badge-expired" };
  if (days === 0) return { label: "Scade oggi", cls: "badge-expired" };
  if (days <= daysThreshold) return { label: `${days}g alla scadenza`, cls: "badge-expiring" };
  return { label: "In corso", cls: "badge-good" };
}

export function formatCurrency(n) {
  if (n === null || n === undefined) return "—";
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(n);
}
